import { memo } from 'react'
import QuickTradeConditionalEntry, {
    QuickTradeConditionalEntryProps,
} from '../../quickTradeWindow/QuickTradeConditionalEntry'
import {
    BasketWeightedMarketParams,
    useBasketWeightedMarketPrices,
} from './useBasketWeightedMarketPrices'

type BasketConditionalEntrySlotProps = {
    priceParams: BasketWeightedMarketParams
    entryProps: Omit<QuickTradeConditionalEntryProps, 'lastPrice' | 'lastVolume'>
}

const BasketConditionalEntrySlot = ({ priceParams, entryProps }: BasketConditionalEntrySlotProps) => {
    const { basketWeightedLastPrice, basketAvgVolume } = useBasketWeightedMarketPrices(priceParams)
    return (
        <QuickTradeConditionalEntry
            {...entryProps}
            lastPrice={basketWeightedLastPrice}
            lastVolume={basketAvgVolume}
        />
    )
}

export default memo(BasketConditionalEntrySlot)
